import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from './user/userSlice';
import sharedStoreReducer from './sharedStore/sharedStoreSlice';
import folderReducer from './folders/foldersSlice';
import groupsReducer from './groups/groupsSlice';
import subGroupsReducer from './subGroups/subGroupsSlice';
import composersReducer from './composers/composersSlice';
import videoReducer from './videos/videoSlice';
import videoFeedsListReducer from './videoFeedsList/videoFeedsListSlice';
import downloadManagerReducer from './downloadManager/downloadManagerSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    sharedStore: sharedStoreReducer,
    folderStore: folderReducer,
    groupsStore: groupsReducer,
    subGroupsStore: subGroupsReducer,
    composersStore: composersReducer,
    videoStore: videoReducer,
    videoFeedsListStore: videoFeedsListReducer,
    downloadManagerStore: downloadManagerReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
